import { DesignSystem } from '@/src/design-system'
import { MainWrapper } from '@/src/common/wrappers/MainWrapper'
import { MesaLogo } from '@/src/assets/icons/MesaLogo'
import { H1, H4, Paragraph, Separator, SizableText, View, YStack } from 'tamagui'
import * as Components from '../../components'
import * as E2E from '../../e2e'
import * as Stores from '../../stores'
import { mesaColorNames } from '@/src/common/theme'
import { openInAppBrowser } from '@/src/common/utils/openInAppBrowser'

export function EarnOnMortgageIndex() {
  const { data: awardQueryResult, isLoading: awardQueryLoading } = Stores.MortgageEarnApi.endpoints[
    'GET /mortgage/earn'
  ].useQuery({}, { refetchOnMountOrArgChange: true })

  if (awardQueryLoading) {
    return <DesignSystem.Loading.Screen />
  }

  const { latestMonthlyAward, activeMonthlyAward } = awardQueryResult ?? {}
  const { awardAmountInPoints: latestAwardAmount } = latestMonthlyAward ?? {}
  const { awardAmountInPoints: activeAwardAmount } = activeMonthlyAward ?? {}

  const isProgramEnrolled = Boolean(activeAwardAmount || latestAwardAmount)

  return (
    <MainWrapper
      screen="/main/home/earn-on-mortgage"
      testID={E2E.Config.Ids.View.EarnOnMortgageIndex}
      showProfile={false}
      headerSectionProps={{
        backLinkProps: { href: '/main/home', dismissTo: true },
        backProps: { testID: E2E.Config.Ids.Press.IndexBack },
        style: { marginBottom: 0 },
        title: 'Mesa Home',
      }}
    >
      <View flex={1} mx="auto" maxW={768} pb={32}>
        <DesignSystem.SplitCard style={{ flex: 1 }}>
          <DesignSystem.SplitCard.Header
            containerStyle={{
              paddingHorizontal: 16,
              paddingVertical: 32,
              height: 200,
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <MesaLogo variant="dualtone-white" width={145} height={56} />
            <H1 color="white" text="center">
              Home
            </H1>
          </DesignSystem.SplitCard.Header>
          <DesignSystem.SplitCard.Content style={{ gap: 16 }}>
            <YStack items="stretch" minW={0} flex={1} gap={16}>
              <H4>Earn 1X Mesa Points per dollar on your monthly mortgage payments</H4>
              <Paragraph>
                With verification, you’ll earn 1X Mesa Points on your monthly mortgage payment (up
                to 100,000 points annually) when you spend at least $1,000 per month on eligible
                purchases with your Mesa Homeowners Card. Only one mortgage is eligible for rewards
                per cardmember. If you have multiple mortgages, you may select the one with the
                highest monthly payment.
              </Paragraph>
              <SizableText
                color={mesaColorNames['Mesa Primary Scale/400 - Brand #00DFC9']}
                cursor="pointer"
                textDecorationLine="underline"
                onPress={() => {
                  void openInAppBrowser(
                    'https://mesamember.com/legal/mesa-membership-terms-and-conditions',
                    'Terms and Conditions',
                  )
                }}
              >
                Terms and conditions apply.
              </SizableText>
              <Separator />
              {!isProgramEnrolled && <Components.ProgramUnenrolled />}
              {isProgramEnrolled && <Components.ProgramEnrolled />}
            </YStack>
          </DesignSystem.SplitCard.Content>
        </DesignSystem.SplitCard>
      </View>
    </MainWrapper>
  )
}
